import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service'
import type {ButtonAttrs} from '@jetbrains/ring-ui/components/button/button'
import Button from '@jetbrains/ring-ui/components/button/button'
import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Routes, {getHref} from '../../../../../../routes'
import {restApi} from '../../../../../../services/rest'
import {noop} from '../../../../../../utils/empty'
import {usePipelineId} from '../../../hooks/pipeline'
import {serializeError} from '../../../utils/error'

type Props = ButtonAttrs & {
  headId: string
  beforeRun?: () => unknown
  afterRun?: () => unknown
  pipelineId?: string
  branchName?: string
}

export default function RunButton({
  headId,
  beforeRun = noop,
  afterRun = noop,
  children = 'Run',
  pipelineId,
  branchName,
  ...restProps
}: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const [addBuildToQueue] = restApi.endpoints.addBuildToQueue.useMutation()
  const pipelineIdFromUrl = usePipelineId()
  const navigate = useNavigate()

  return (
    <Button
      onClick={async () => {
        setIsLoading(true)
        try {
          await beforeRun()
          const result = await addBuildToQueue({build: {buildType: {id: headId}, branchName}})
          if ('error' in result) {
            alertService.error(serializeError(result.error))
          } else {
            const triggeredId = result.data.id!
            afterRun()
            navigate(
              getHref(Routes.PIPELINE_RUN, {
                id: pipelineId ?? pipelineIdFromUrl,
                runId: String(triggeredId),
              }),
            )
          }
        } finally {
          setIsLoading(false)
        }
      }}
      loader={isLoading}
      {...restProps}
    >
      {children}
    </Button>
  )
}
